export default "__VITE_ASSET__c85e0187__"